import { ArrowForward } from '@mui/icons-material';

import { Box, Typography } from '@sbv-clients/ui-shared';

export const ViewAllButton = ({
  color = 'grey.500',
  onClick,
}: {
  color?: string;
  onClick?: () => void;
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={0.5}
      onClick={onClick}
      sx={{ cursor: onClick ? 'pointer' : 'default', color }}
    >
      <Typography variant="body2" color={color}>
        View all
      </Typography>
      <ArrowForward fontSize="small" />
    </Box>
  );
};
